import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import backArrowIcon from '../../assets/img/back-arrow.png';
import exportIcon from '../../assets/icon/icon-export-excel.svg';
import axios from 'axios';
import { API_URL } from '../../utils/constant';
import { formatReceiptCurrency } from '../../utils/format-number';
import * as XLSX from 'xlsx';
import { Pagination } from '../../components/Pagination';

const LIMIT = 20;

const RetailCustomerReport = () => {
    const backPath = '/report/list';
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const visibleData = data.slice((page - 1) * LIMIT, page * LIMIT);

    const fetchRetailCustomerReport = () => {
        const url = API_URL + '/retailCustomer?status=ACTIVE&limit=100000&page=1&sort=-created_date';
        return axios
            .get(url, {
                withCredentials: true,
            })
            .then((response) => {
                setData(response?.data?.data || []);
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    useEffect(() => {
        fetchRetailCustomerReport();
    }, []);

    useEffect(() => {
        setPage(1);
    }, [data]);

    const handleExportClick = (fileName) => {
        const table = document.querySelector('#xlsx-export-all').cloneNode(true);
        const workbook = XLSX.utils.table_to_book(table, { display: false });
        XLSX.writeFile(workbook, fileName);
    };

    return (
        <div className='sub-page-layout-1'>
            <div className='container' style={{ height: 'auto' }}>
                <div className='report-page-header text-3xl'>
                    <div className='report-page-heading'>
                        <Link className='back-to-page' to={backPath}>
                            <img src={backArrowIcon} />
                            Back
                        </Link>
                        <h1 className='sub-page-title'>Retail Customer Report</h1>
                    </div>

                    <div className='report-toolbar'>
                        <button
                            className='gold-btn report-export-button'
                            onClick={() => {
                                handleExportClick('Retail_Customer_Report.xlsx');
                            }}
                        >
                            <img src={exportIcon} alt='export excel icon' />
                            <span>Export Excel</span>
                        </button>
                    </div>
                </div>
                <div className='table-container'>
                    <table className='x-table' id='xlsx-export'>
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Phone Number</th>
                                <th>Address</th>
                                <th>Card Number</th>
                                <th>Point</th>
                                <th className='report-amount'>Advanced MMK</th>
                                <th className='report-amount'>Advanced THB</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleData?.map((item, i) => (
                                <tr key={i}>
                                    <td>{item['customer_name']}</td>
                                    <td>{item['phone1']}</td>
                                    <td>{item['address']}</td>
                                    <td>{item['member_code']}</td>
                                    <td>{item['loyalty_points']}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['advanced_mmk'], 'MMK')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['advanced_thb'], 'THB')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{ display: 'none' }}>
                    <table id='xlsx-export-all'>
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Phone Number</th>
                                <th>Address</th>
                                <th>Card Number</th>
                                <th>Point</th>
                                <th className='report-amount'>Advanced MMK</th>
                                <th className='report-amount'>Advanced THB</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item, i) => (
                                <tr key={`export-${i}`}>
                                    <td>{item['customer_name']}</td>
                                    <td>{item['phone1']}</td>
                                    <td>{item['address']}</td>
                                    <td>{item['member_code']}</td>
                                    <td>{item['loyalty_points']}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['advanced_mmk'], 'MMK')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['advanced_thb'], 'THB')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className='w-full flex justify-end mt-4'>
                    <Pagination page={page} totalCount={data.length} limit={LIMIT} onChange={setPage} />
                </div>
            </div>
        </div>
    );
};

export default RetailCustomerReport;
